"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const Input_1 = require("@components/atoms/Input");
const AccountInHeader_1 = require("@components/organisms/AccountInHeader");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
const _api_1 = __importDefault(require("@api"));
const _store_1 = __importDefault(require("@store")); // Component
var AccountLoginForm = function AccountLoginForm() {
    var _useGlobal = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal[1];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.notification;
    }, function (actions) {
        return actions.setNotification;
    }), setNotification = _useGlobal2[1];
    var _useGlobal3 = _store_1.default(function (state) {
        return state.regBundle;
    }, function (actions) {
        return actions.setRegBundle;
    }), setRegBundle = _useGlobal3[1];
    var _React$useState = react_1.default.useState(false), processing = _React$useState[0], setProcessing = _React$useState[1];
    var _React$useState2 = react_1.default.useState(''), email = _React$useState2[0], setEmail = _React$useState2[1];
    var login = function login() {
        setProcessing(true);
        _api_1.default('login', {
            email: email
        }).then(function (r) {
            setProcessing(false);
            if (r.status !== 204) {
                setNotification({
                    type: 'warning',
                    title: 'Login error',
                    message: 'We could not process your login attempt. Is your email correct?'
                });
                return;
            }
            setPanel('checkEmail');
        }).catch(function (e) {
            return console.log(e);
        });
    };
    var _React$useState3 = react_1.default.useState(false), formValid = _React$useState3[0], setFormValid = _React$useState3[1];
    react_1.default.useEffect(function () {
        setFormValid(/\S+@\S+\.\S+/.test(email));
        setRegBundle({
            email: email
        });
    }, [email]);
    var submitSigninForm = function submitSigninForm(event) {
        event.preventDefault();
        login();
    };
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, null, /*#__PURE__*/ react_1.default.createElement(StyledImage, {
        src: "/images/accounts/login.png",
        objectFit: "cover"
    }), /*#__PURE__*/ react_1.default.createElement(ColumnHeader, null, "Become a Member"), /*#__PURE__*/ react_1.default.createElement(Caption, null, "A PRIOR membership includes access to our immersive global journeys, community gatherings, inspiration and travel intelligence."), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.ButtonWrapper, {
        shortPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        size: "large",
        type: "gold",
        shadow: true,
        display: "flex",
        onClick: function onClick() {
            return setPanel('pricing');
        }
    }, "Discover More"))), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, null, /*#__PURE__*/ react_1.default.createElement("form", {
        onSubmit: function onSubmit(e) {
            return submitSigninForm(e);
        }
    }, /*#__PURE__*/ react_1.default.createElement(StyledImage, {
        src: "/images/accounts/register.png",
        objectFit: "cover"
    }), /*#__PURE__*/ react_1.default.createElement(ColumnHeader, null, "Sign In"), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "email",
        value: email,
        label: "Email Address",
        name: "email",
        onChange: function onChange(_ref) {
            var value = _ref.target.value;
            return setEmail && setEmail(value);
        },
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.ButtonWrapper, {
        shortPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, Object.assign({
        shadow: true,
        size: "large",
        display: "flex",
        disabled: processing || !formValid,
        onClick: function onClick() {
            return login();
        }
    }, {
        processing: processing
    }), "Sign In")))));
}; // Styling
var StyledImage = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Image, props);
}).withConfig({
    displayName: "AccountLoginForm__StyledImage",
    componentId: "aa8taj-0"
})(["height:100px;margin-bottom:32px;", "{height:120px;}", "{height:140px;margin-bottom:40px;}", "{height:160px;margin-bottom:48px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var ColumnHeader = styled_components_1.default.h2.withConfig({
    displayName: "AccountLoginForm__ColumnHeader",
    componentId: "aa8taj-1"
})(["margin-bottom:24px;", " color:", ";&::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.1) * 1em);}&::after{margin-bottom:calc((1 - 1.4) * 1em);}", "{margin-bottom:40px;}", "{margin-bottom:56px;}", "{margin-bottom:64px;}"], _theme_1.type.h2, _theme_1.palette.black, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Caption = styled_components_1.default.p.withConfig({
    displayName: "AccountLoginForm__Caption",
    componentId: "aa8taj-2"
})(["margin-bottom:16px;", " ", "{min-height:72px;margin-bottom:0;}", "{min-height:80px;}", "{min-height:88px;}"], _theme_1.type.pSansNew, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.default = AccountLoginForm;
